"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingMethodLabel = void 0;
const core_1 = require("@material-ui/core");
const React = require("react");
const styles = core_1.createStyles({
    row: {
        display: "flex"
    },
    label: {
        marginRight: ".5rem",
        fontWeight: 600
    },
    value: {}
});
const decorate = core_1.withStyles(styles);
class ShippingMethodLabelUnstyled extends React.Component {
    render() {
        const { shippingMethods = [], classes } = this.props;
        return (React.createElement("div", null, shippingMethods
            ? shippingMethods.map((method, index) => (React.createElement("div", { className: classes.row, key: index },
                React.createElement(core_1.Typography, { className: classes.label, gutterBottom: true },
                    method.distributor,
                    ":"),
                React.createElement(core_1.Typography, { gutterBottom: true }, method.method))))
            : []));
    }
}
exports.ShippingMethodLabel = decorate(ShippingMethodLabelUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-review/components/shipping-method-label/shipping-method-label.tsx
// module id = 3587
// module chunks = 0